export const GoogleMapApiConfig = 'AIzaSyBpDcFpMa3kaofT9k3iokxn6eHI2pohKsA';